import { h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "../I18n";
import { formatAddress } from "restaumatic-client/src/presentation";
import Alert from "./Alert";
function RestaurantDeliveryAddressWarning(props) {
    const { state } = props;
    switch (state.type) {
        case "NetworkError":
            return (h(Alert, { type: "danger", message: translate(t.errors.messages.network) }));
        case "RestaurantDoesntDeliverTo": {
            const address = formatAddress(state.streetAddress, state.streetAddress.isPostCodeRequired);
            return (h(Alert, { type: "danger", message: translate(t.delivery.not_possible, {
                    address: `${address.firstLine}, ${address.secondLine}`,
                }) }));
        }
        case "ChangeRestaurant":
            const { name, path } = state.restaurantInfo;
            return (h(Alert, { type: "warning", message: translate(t.delivery.change_restaurant), link: {
                    label: name,
                    path,
                    gaAction: "Change restaurant with alternative link",
                    customClass: "btn btn-warning",
                    fieldId: "change-restaurant-link",
                } }));
        default:
            return null;
    }
}
export default observer(RestaurantDeliveryAddressWarning);
